<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="All flags from Flag Icon CSS" url="http://flag-icon-css.lip.is/" />
    <vc-layout :spacing="8">
      <vc-col :span="6" md12>
        <vc-switcher v-model="round" name="round" color="indigo" style="margin-top: 17px;">round flags</vc-switcher>
      </vc-col>
      <vc-col :span="6" md12>
        <vc-radio-group name="ratio" direction="horizontal" v-model="ratio" color="indigo" style="margin-top: 17px;">
          <vc-radio :disabled="round" value="4x3">4 x 3 ratio</vc-radio>
          <vc-radio value="1x1">1 x 1 ratio</vc-radio>
        </vc-radio-group>
      </vc-col>
      <vc-col :span="6" md12>
        <vc-select color="indigo" name="size" v-model="size" :items="sizes" />
      </vc-col>
      <vc-col :span="6" md12>
        <vc-text v-model="search" placeholder="Search countries..." name="search" color="indigo" autofocus />
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="3" sm6 xs12 v-for="(country, index) in filteredCountries" :key="index" :class="['align-center']">
        <h4 v-html="country.name" :class="nameCss" />
        <vc-flag :round="round" :size="size[0].value" :ratio="ratio" :iso="country.code" :class="['elevation-12']" />
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'FlagPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      countries: [],
      round: false,
      search: '',
      size: [{
        label: 'Size 3',
        value: '3'
      }],
      sizes: [{
        label: 'Size 1',
        value: '1'
      }, {
        label: 'Size 2',
        value: '2'
      }, {
        label: 'Size 3',
        value: '3'
      }, {
        label: 'Size 4',
        value: '4'
      }, {
        label: 'Size 5',
        value: '5'
      }, {
        label: 'Size 6',
        value: '6'
      }],
      ratio: '4x3',
      nameCss: ['body-2', 'font-grey', 'font-l-600', 'ellipsis']
    }
  },
  watch: {
    round () {
      if (this.round) {
        this.ratio = '1x1'
      }
    }
  },
  computed: {
    filteredCountries () {
      return this.countries.filter((data) => {
        return data.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
      })
    }
  },
  mounted () {
    this.$root.$emit(this.$store.state.events.ajaxStart)
    this.$http('/static/data/countries.json').then(response => {
      this.countries = response.data.countries
      this.getPage()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/flag.vue